<template>
  <div class="header">
    <router-link class="warnning-bell-warp" to="/repeat-data">
      <a-badge :count="sysRepeatDataNum">
        <a-icon style="font-size: 18px; padding: 4px" type="bell" />
      </a-badge>
    </router-link>

    <a-dropdown class="header-item">
      <a class="ant-dropdown-link" href="#">
        <a-avatar v-if="userInfo.userLogoUrl" :src="userInfo.userLogoUrl" />
        <!-- <a-avatar v-else icon="user" /> -->
        <img
          v-else
          class="default-avatar"
          src="../assets/logo.png"
          alt="logo"
        />

        <span style="vertical-align: middle;margin-left:10px">
          {{ userInfo.userName || userInfo.loginName }}
          ({{ userInfo.rootDeptName }})
        </span>
      </a>
      <a-menu slot="overlay">
        <a-menu-item @click="handlerToUserCenter">
          <a-icon type="setting" style="margin-right: 10px" />{{
            $t('layoutsHeader.userCenter')
          }}
        </a-menu-item>
        <a-menu-item>
          <a href="javascript:;" @click="handlerSignOut">
            <a-icon type="logout" style="margin-right: 10px" />{{
              $t('layoutsHeader.loginOut')
            }}
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>

    <LangSelect></LangSelect>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import LangSelect from '../components/LangSelect'
import { userSignOut } from '@/api/userMana'

export default {
  components: {
    LangSelect
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo || {},
      sysRepeatDataNum: state => state.sysRepeatDataStore.sysRepeatDataNum
    })
  },
  methods: {
    ...mapMutations([
      'refreshUserInfo',
      'resetKeepAliveInclude',
      'resetSysRepeatDataNum',
      'setEnumsData',
      'setOrgTreeSourceData'
    ]),
    handlerToUserCenter(){
      this.$router.push({ path: '/user-center/index', query: {} })
    },
    async handlerSignOut() {
      try {
        await userSignOut()

        this.refreshUserInfo(null)
        this.resetKeepAliveInclude()
        this.resetSysRepeatDataNum()
        this.setEnumsData({})
        this.setOrgTreeSourceData([])

        this.$router.push({ path: '/user' })
      } catch (error) {}
    }
  }
}
</script>

<style scoped>
.header {
  float: right;
  padding-right: 16px;
}
.header-item {
  display: inline-block;
  height: 100%;
  padding: 0 12px;
  cursor: pointer;
  transition: all 0.3s;
  color: rgba(0, 0, 0, 0.65);
}
.header-item:hover {
  background-color: rgba(0, 0, 0, 0.025);
}

.warnning-bell-warp {
  height: 100%;
  padding: 0 12px;
  display: inline-block;
  margin-right: 14px;
  vertical-align: middle;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.65);
}

.default-avatar {
  /* width: 32px; */
  height: 32px;
  /* border-radius: 50%; */
}
</style>
